import React from "react";
import { Row, Col, Form, Switch, Select, Slider, Segmented } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";

import ProfileFormGroup from "./ProfileFormGroup";

const SettingsSongOptions = ({ currentPlayer, userData, setProfile }) => {
    let profileDataKey;

    if (currentPlayer === 1) {
        profileDataKey = "profile_p1";
    } else {
        profileDataKey = "profile_p2";
    }

    const handleOnChange = (changedFields) => {
        let songOptionObject = {
            ...userData[profileDataKey].userSongOptions,
        };

        changedFields.forEach((field) => {
            let name = field.name[0];
            let value = field.value;

            if (
                name === "giveUp" ||
                name === "vanish" ||
                name === "inverse" ||
                name === "voice"
            ) {
                // Bool to Int
                songOptionObject[name] = value ? 1 : 0;
            } else {
                songOptionObject[name] = value;
            }
        });

        setProfile(
            {
                ...userData[profileDataKey],
                userSongOptions: songOptionObject,
            },
            currentPlayer
        );
    };

    return (
        <Row
            gutter={16}
            style={{
                marginBottom: `16px`,
            }}
        >
            <Col span={24}>
                <ProfileFormGroup
                    cardProps={{
                        title: "Song Options",
                    }}
                    formProps={{
                        onFieldsChange: handleOnChange,
                        fields: [
                            {
                                name: ["speed"],
                                value: userData[profileDataKey].userSongOptions
                                    .speed,
                            },
                            {
                                name: ["vanish"],
                                value: userData[profileDataKey].userSongOptions
                                    .vanish,
                            },
                            {
                                name: ["inverse"],
                                value: userData[profileDataKey].userSongOptions
                                    .inverse,
                            },
                            {
                                name: ["random"],
                                value: userData[profileDataKey].userSongOptions
                                    .random,
                            },
                            {
                                name: ["giveUp"],
                                value: userData[profileDataKey].userSongOptions
                                    .giveUp,
                            },
                            {
                                name: ["noteOffset"],
                                value: userData[profileDataKey].userSongOptions
                                    .noteOffset,
                            },
                            {
                                name: ["voice"],
                                value: userData[profileDataKey].userSongOptions
                                    .voice,
                            },
                            {
                                name: ["instrument"],
                                value: userData[profileDataKey].userSongOptions
                                    .instrument,
                            },
                        ],
                    }}
                >
                    <Form.Item name="speed" label="Speed">
                        <Select>
                            <Select.Option value={0}>Normal</Select.Option>
                            <Select.Option value={1}>1.1x</Select.Option>
                            <Select.Option value={2}>1.2x</Select.Option>
                            <Select.Option value={3}>1.3x</Select.Option>
                            <Select.Option value={4}>1.4x</Select.Option>
                            <Select.Option value={5}>1.5x</Select.Option>
                            <Select.Option value={6}>1.6x</Select.Option>
                            <Select.Option value={7}>1.7x</Select.Option>
                            <Select.Option value={8}>1.8x</Select.Option>
                            <Select.Option value={9}>1.9x</Select.Option>
                            <Select.Option value={10}>2x</Select.Option>
                            <Select.Option value={11}>2.5x</Select.Option>
                            <Select.Option value={12}>3x</Select.Option>
                            <Select.Option value={13}>3.5x</Select.Option>
                            <Select.Option value={14}>4x</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Vanish"
                        name="vanish"
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Inverse"
                        name="inverse"
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                        />
                    </Form.Item>
                    <Form.Item label="Random" name="random">
                        <Segmented
                            options={[
                                {
                                    label: "Off",
                                    value: 0,
                                },
                                {
                                    label: "Whimsical",
                                    value: 1,
                                },
                                {
                                    label: "Messy",
                                    value: 2,
                                },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Give Up"
                        name="giveUp"
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                        />
                    </Form.Item>
                    <Form.Item label="Note Offset" name="noteOffset">
                        <Slider
                            min={-5}
                            max={5}
                            included={false}
                            dots={true}
                            tooltipVisible={false}
                            marks={{
                                "-5": "-5",
                                "-4": "-4",
                                "-3": "-3",
                                "-2": "-2",
                                "-1": "-1",
                                0: "0",
                                1: "+1",
                                2: "+2",
                                3: "+3",
                                4: "+4",
                                5: "+5",
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Voice"
                        name="voice"
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                        />
                    </Form.Item>
                    <Form.Item label="Instrument" name="instrument">
                        <Select>
                            <Select.Option value={0}>Taiko</Select.Option>
                            <Select.Option value={1}>Festival</Select.Option>
                            <Select.Option value={2}>Dogs & Cats</Select.Option>
                            <Select.Option value={3}>Deluxe</Select.Option>
                            <Select.Option value={4}>Drumset</Select.Option>
                            <Select.Option value={5}>Tambourine</Select.Option>
                            <Select.Option value={6}>Don Wada</Select.Option>
                            <Select.Option value={7}>Clapping</Select.Option>
                            <Select.Option value={8}>Conga</Select.Option>
                            <Select.Option value={9}>8-Bit</Select.Option>
                            <Select.Option value={10}>Heave-ho</Select.Option>
                            <Select.Option value={11}>Mecha</Select.Option>
                            <Select.Option value={12}>Bujain</Select.Option>
                            <Select.Option value={13}>Rap</Select.Option>
                            <Select.Option value={14}>Hosogai</Select.Option>
                            <Select.Option value={15}>Akemi</Select.Option>
                            <Select.Option value={16}>Synth Drum</Select.Option>
                            <Select.Option value={17}>Shuriken</Select.Option>
                            <Select.Option value={18}>Bubble Pop</Select.Option>
                            <Select.Option value={19}>
                                Electric Guitar
                            </Select.Option>
                        </Select>
                    </Form.Item>
                </ProfileFormGroup>
            </Col>
        </Row>
    );
};

export default SettingsSongOptions;
